module.exports = __webpack_public_path__ + "img/01.438fc4a8.jpg";